import { render, staticRenderFns } from "./AulaTemplate.vue?vue&type=template&id=52515c57&scoped=true"
import script from "./AulaTemplate.vue?vue&type=script&lang=js"
export * from "./AulaTemplate.vue?vue&type=script&lang=js"
import style0 from "./AulaTemplate.vue?vue&type=style&index=0&id=52515c57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52515c57",
  null
  
)

export default component.exports